let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jkTol"), load("ffEVr"), load("5xpVW")]).then(() => parcelRequire('babkf'));